import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import parseHostname from '@peloton/env/parseHostname';
import { toKubernetesApi as toStageNKubernetesApi } from '@peloton/env/toApiEnv';
import { ApiEnvs } from '@peloton/external-links/models';
import { isDefined } from '@peloton/types';
import * as Env from './env';

var isApiEnv = function isApiEnv(value) {
  return isDefined(value) && Object.keys(ApiEnvs).map(function (k) {
    return ApiEnvs[k];
  }).some(function (v) {
    return v === value;
  });
};

export var DefaultApiOverrideGetter = function DefaultApiOverrideGetter() {
  return null;
};
export var toApiEnv = function toApiEnv(hostname) {
  var getApiOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultApiOverrideGetter;
  var api = getApiOverride();
  var isStagingEnv = Env.isStagingEnv(hostname);
  var isUatEnv = Env.isUatEnv(hostname);
  var defaultApi = isUatEnv && !isStagingEnv ? ApiEnvs.Qa1 : ApiEnvs.Prod; // check for predefined api environment override

  if (isApiEnv(api)) {
    return api;
  } else if (isDefined(api)) {
    // check for kubernetes override
    var kubeApiEnv = toKubernetesApiFromHostname(api);

    if (kubeApiEnv) {
      return kubeApiEnv;
    }
  } // custom api flag is __api-<api machine address with _ instead of .>


  var hostnameMatch = /--.*__api-(.*)__.*\.(secret|test|uat|xtest)\.onepeloton/.exec(hostname); // even though Stage N environments use K8s, they have slightly different schemes

  var stageNEnvMatch = /--api-core-(.*)--stage/.exec(hostname);

  if (stageNEnvMatch && stageNEnvMatch[1]) {
    return toStageNKubernetesApi(parseHostname(hostname)['api']);
  } // TODO: remove when we stop using api-qa envs


  var hostMatchOldPattern = hostname.indexOf('api-qa') > -1 ? 'qa1' : false;
  var parsedHostname = hostnameMatch && hostnameMatch[1] // Remove extra flags from greedy regex
  .split('__')[0];
  var apiServer = parsedHostname && (parsedHostname.includes('k8s--') ? toKubernetesApi(parsedHostname) : parsedHostname) || hostMatchOldPattern;
  return apiServer ? apiServer : defaultApi;
};

var toKubernetesApiFromHostname = function toKubernetesApiFromHostname(hostname) {
  var _$exec;

  return (_$exec = /(api(\.|-)(?:\w*|\w*-\w*)\.(dev|stage)\.k8s)\.pelotime\.com$/.exec(hostname)) === null || _$exec === void 0 ? void 0 : _$exec[1];
};

var toKubernetesApi = function toKubernetesApi(api) {
  var _api$replace$split = api.replace('k8s--', '').split('--'),
      _api$replace$split2 = _slicedToArray(_api$replace$split, 2),
      service = _api$replace$split2[0],
      _api$replace$split2$ = _api$replace$split2[1],
      context = _api$replace$split2$ === void 0 ? 'dev' : _api$replace$split2$;

  return "api-".concat(service, ".").concat(context, ".k8s");
};

export var isQaApiEnv = function isQaApiEnv() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
  var getOverride = arguments.length > 1 ? arguments[1] : undefined;
  var apiEnv = toApiEnv(hostname, getOverride);
  return apiEnv === ApiEnvs.Qa1 || apiEnv === ApiEnvs.Qa2;
};
export var isProdApi = function isProdApi(getOverride) {
  return toApiEnv(window.location.hostname, getOverride) === ApiEnvs.Prod;
};
export var isLocalApiEnv = function isLocalApiEnv(getOverride) {
  return toApiEnv(window.location.hostname, getOverride) === ApiEnvs.Local;
};